export const PASSWORD_MIN_LENGTH = 12;

// These are the non-alphanumeric characters Firebase documents as satisfying
// its password-policy requirement.
export const PASSWORD_SPECIAL_CHARACTERS = "^$*.[]{}()?\"!@#%&/\\,><':;|_~";

export type PasswordRequirement = {
  id: "length" | "uppercase" | "lowercase" | "number" | "special";
  label: string;
  met: boolean;
};

export const getPasswordRequirements = (password: string): PasswordRequirement[] => [
  {
    id: "length",
    label: `At least ${PASSWORD_MIN_LENGTH} characters`,
    met: password.length >= PASSWORD_MIN_LENGTH,
  },
  {
    id: "uppercase",
    label: "One uppercase letter",
    met: /[A-Z]/.test(password),
  },
  {
    id: "lowercase",
    label: "One lowercase letter",
    met: /[a-z]/.test(password),
  },
  {
    id: "number",
    label: "One number",
    met: /[0-9]/.test(password),
  },
  {
    id: "special",
    label: "One special character",
    met: Array.from(password).some((character) =>
      PASSWORD_SPECIAL_CHARACTERS.includes(character)
    ),
  },
];

export const passwordMeetsPolicy = (password: string): boolean =>
  getPasswordRequirements(password).every((requirement) => requirement.met);

export const getPasswordPolicyError = (password: string): string => {
  const missing = getPasswordRequirements(password)
    .filter((requirement) => !requirement.met)
    .map((requirement) => requirement.label.toLowerCase());

  return missing.length === 0
    ? ""
    : `Password must include ${missing.join(", ")}.`;
};

export const PASSWORD_POLICY_SUMMARY =
  "At least 12 characters with an uppercase letter, lowercase letter, number, and special character.";
